import { render, staticRenderFns } from "./render-video-script.vue?vue&type=template&id=57cca55a&"
import script from "./render-video-script.vue?vue&type=script&lang=js&"
export * from "./render-video-script.vue?vue&type=script&lang=js&"
import style0 from "./render-video-script.vue?vue&type=style&index=0&id=57cca55a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports